import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Container,
  Card,
  CardContent,
   IconButton,
    AppBar,
    Toolbar,
  CircularProgress,
} from "@mui/material";
import { BASE_URL } from "../../Api/ApiUrls";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";
import SuccessAlert from '../../../Components/Users/Alertpage/SuccessAlert/SuccessAlert';
import FailureAlert from '../../../Components/Users/Alertpage/FailureAlert/FailureAlert';
import DeleteFailureAlert from "../Alertpage/DeleteAlert/DeleteFailureAlert";
import DeleteSuccessAlert from "../Alertpage/DeleteAlert/DeleteSuccessAlert";


const DeleteAccountConfirm = () => { 
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
const [showSuccess, setShowSuccess] = useState(false);
const [showFailure, setShowFailure] = useState(false);
const [alertMessage, setAlertMessage] = useState("");


const handleDelete = async () => {
  setLoading(true);

  const response = await fetch(`${BASE_URL}/users/${id}/`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (response.ok) {
    console.log("✅ Account deleted successfully");

    // Clear user session
    localStorage.clear();
    sessionStorage.clear();

    setAlertMessage("Your account has been deleted successfully.");
    setShowSuccess(true);
  } 
  else {
    let errorMessage = "Failed to delete account. Please try again.";

    try {
      const errorData = await response.json();
      if (errorData?.message) {
        errorMessage = errorData.message;
      }
    } catch (error) {
      console.error("Error parsing response:", error);
    }

    console.error("❌ Delete account failed");

    setAlertMessage(errorMessage);
    setShowFailure(true);
  }

  setLoading(false);
};


  return (
     <Box sx={{ 
         display: 'flex',
         flexDirection: 'column',
         minHeight: '100vh',
         background: `
           linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
           url('https://www.transparenttextures.com/patterns/cream-paper.png')
         `,
         backgroundSize: 'cover',
         backgroundAttachment: 'fixed'
       }}>
          <AppBar 
                position="static" 
                elevation={0}
                sx={{ 
                  background: `
                    linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)),
                    url('https://www.transparenttextures.com/patterns/dark-matter.png')
                  `,
                  color: 'text.primary',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
                }}
              >
                <Toolbar sx={{ minHeight: 64 }}>
                  <IconButton 
                    edge="start" 
                    onClick={() => navigate(-1)}
                    sx={{ 
                      color: '#ffffff',
                      backgroundColor: 'rgba(255,255,255,0.1)',
                      '&:hover': { 
                        backgroundColor: 'rgba(255,255,255,0.2)' 
                      }
                    }}
                  >
                    <ArrowBackIosNewIcon />
                  </IconButton>
                  <Typography variant="h6" sx={{ flexGrow: 1, ml: 2, color: 'white' }}>
                    Delete Account
                  </Typography>
                </Toolbar>
              </AppBar>

      <Container maxWidth="sm justify-content-center" sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' , mb: 8}}>
        <Card sx={{ borderRadius: 3 }}>
          <CardContent sx={{ textAlign: "center", p: 4 }}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
              Are you sure?
            </Typography>

           <Typography
  variant="body2"
  sx={{ color: "text.secondary", mb: 3, lineHeight: 1.6 }}
>
  By deleting your account, <b>you will permanently lose access</b> to all your
  personal data including <b>properties, subscriptions, saved items, payments,
  and account history</b>. This action is <b>irreversible</b> and once confirmed,
  <b>your account cannot be recovered</b>.
</Typography>


            {loading ? (
              <CircularProgress sx={{ color: "black" }} />
            ) : (
              <>
                <Button
                  fullWidth
                  variant="contained"
                  color="error"
                  sx={{ mb: 2, borderRadius: 3 }}
                  onClick={handleDelete}
                >
                  Yes, Delete My Account
                </Button>

                <Button
                  fullWidth
                  variant="outlined"
                  sx={{ borderRadius: 3 }}
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>
              </>
            )}
          </CardContent>
        </Card>
      </Container>


      {showSuccess && (
        <DeleteSuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowSuccess(false);
           navigate("/", { replace: true });
          }}
        />
      )}
      
      {showFailure && (
        <DeleteFailureAlert
          message={alertMessage}
          onClose={() => {
            console.log("Closing failure alert"); // Debug log
            setShowFailure(false);
            setAlertMessage(""); 
           
             navigate(`/delete-account/${id}`);
          }}
        />
      )}
        <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
              <FormsBottomNavbar />
            </Box>
    </Box>
  );
};

export default DeleteAccountConfirm;
